import { apiRequest } from '../apiRequest';

function toQueryString(params: Record<string, unknown>) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === '') continue;
    search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export const organisationsActivityAPI = {
  getCommits: async (orgId: string, params: Record<string, unknown> = {}) => {
    const qs = toQueryString(params);
    const data = await apiRequest<any>(`/api/organisations/${orgId}/commits${qs}`, { method: 'GET' });
    return { commits: data.commits ?? [], meta: data.meta ?? null };
  },

  getPullRequests: async (orgId: string, params: Record<string, unknown> = {}) => {
    const qs = toQueryString(params);
    const data = await apiRequest<any>(`/api/organisations/${orgId}/pull-requests${qs}`, {
      method: 'GET',
    });
    return {
      pullRequests: data.pullRequests ?? [],
      stats: data.stats ?? null,
      meta: data.meta ?? null,
    };
  },
};
